<template>
  <div class="periodWorkDetail">
    <!-- <v-card> -->
      <div
          v-if="personelName"
          class="text-color-black mb-3 "
          style="font-size: 1.3rem"
        >
          {{ personelName }}
        </div>
    <!-- </v-card> -->
    <v-card>
      <v-tabs dark background-color="primary " show-arrows>
        <v-tabs-slider color="accent"></v-tabs-slider>

        <v-tab
          class="text-caption"
          v-for="(tab, index) in tabs"
          :key="index"
          :href="'#' + tab.id"
        >
          <span class="font-sahel">{{ $t(tab.title) }}</span>
        </v-tab>

        <v-tab-item value="totalIO">
          <full-period-io-info :args="args" />
        </v-tab-item>
        <v-tab-item value="totalMorakhasi">
          <person-vacation-list :args="args" />
        </v-tab-item>
        <v-tab-item value="totalMissions">
          <person-mission-list :args="args" />
        </v-tab-item>
        <v-tab-item
          v-if="!DisableShowingFunctionality"
          value="detailsFunctionality"
        >
          <functinality-details-tab
            :args="args"
            @onErrorFetchData="onErrorFetchFunctionality"
          />
        </v-tab-item>
        <v-tab-item v-if="!DisableShowingMorLeft" value="detailsMorakhasi">
          <vacation-details :args="args" />
        </v-tab-item>
      </v-tabs>
    </v-card>

    <div class="mt-2" v-if="details">
      <v-expansion-panels v-model="panel" multiple>
        <v-expansion-panel v-for="(item, i) in items" :key="i" class="mt-1">
          <v-card>
            <v-expansion-panel-header color="primary" class="box-title px-2">
              {{ $t(item.title) }}
              <template v-slot:actions>
                <v-icon color="#f2f2f2"> $expand </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              class="content pa-3 ma-0"
              style="background: var(--background-card) !important"
            >
              <div>
                <keep-alive>
                  <component
                    :is="item.content"
                    v-bind="detailsProps"
                  ></component>
                </keep-alive>
              </div>
            </v-expansion-panel-content>
          </v-card>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div class="d-flex py-1">
      <v-spacer></v-spacer>
      <v-btn outlined color="primary" v-if="visiblePrint" @click="print">
        <v-icon left>mdi-printer</v-icon>
        <span class=""> پرینت گزارش </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import FunctionalDetails from "../../components/functionality/periodDetails/FunctionalDetails.vue";
import KasrKarDetails from "../../components/functionality/periodDetails/KasrKarDetails.vue";
import ExtraWorkDetails from "../../components/functionality/periodDetails/ExtraWorkDetails.vue";
import MorakhasiDetails from "../../components/functionality/periodDetails/MorakhasiDetails.vue";
import MamoriatDetails from "../../components/functionality/periodDetails/MamoriatDetails.vue";
import HolidayDetails from "../../components/functionality/periodDetails/HolidayDetails.vue";
import FullPeriodIoInfo from "../../components/functionality/periodDetails/FullPeriodIoInfo/FullPeriodIoInfo.vue";
import PersonVacationList from "../../components/functionality/periodDetails/PersonVacationList/PersonVacationList.vue";
import VacationDetails from "../../components/functionality/periodDetails/VacationDetails/VacationDetails.vue";
import PersonMissionList from "../../components/functionality/periodDetails/PersonMissionList/PersonMissionList.vue";
import FunctinalityDetailsTab from "../../components/functionality/periodDetails/FunctinalityDetailsTab/FunctinalityDetailsTab.vue";
import EosUtils from "../../utils/EosUtils";

export default {
  components: {
    FullPeriodIoInfo,
    PersonVacationList,
    PersonMissionList,
    VacationDetails,
    FunctinalityDetailsTab,
  },
  mounted() {
    this.args.year = this.$route.params.year;
    this.args.period = this.$route.params.period;
    this.args.perno = this.$route.params.perno;
    this.pageLoad();
    this.GetPeriodBeginAndEndDate();
    this.checkVisiblePrint();
    this.getPersonelName();
  },
  computed: {
    detailsProps() {
      return { details: this.details };
    },
  },
  methods: {
    pageLoad() {
      this.$store.dispatch("readwebkartsetting").then((result) => {
        if (result.type === "success") {
          //
          if (result.data.DisableShowingMorLeft === "1") {
            this.DisableShowingMorLeft = true;
            var detailsMorakhasiIndex = this.tabs.findIndex(
              (item) => item.id === "detailsMorakhasi"
            );
            if (detailsMorakhasiIndex) {
              this.tabs.splice(detailsMorakhasiIndex, 1);
            }
          } else {
            this.DisableShowingMorLeft = false;
          }
        }
      });
    },
    onErrorFetchFunctionality() {
      this.DisableShowingFunctionality = true;
      var detailsFunctionalityIndex = this.tabs.findIndex(
        (item) => item.id === "detailsFunctionality"
      );
      if (detailsFunctionalityIndex) {
        this.tabs.splice(detailsFunctionalityIndex, 1);
      }
    },
    GetPeriodBeginAndEndDate() {
      const params = new URLSearchParams();
      params.append("periodNumber", this.args.period);
      params.append("year", this.args.year);
      if (this.args.perno) {
        params.append("employeeId", this.args.perno);
      }

      this.$store
        .dispatch("GetPeriodBeginAndEndDate", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              let data = result.data[0];
              this.GetPersonPeriodWorkDetail(data.Type);
              this.GetPersonDayWorks(data.BeginDate, data.EndDate);
            }
          }
        });
    },
    GetPersonDayWorks(BeginDate, EndDate) {
      const params = new URLSearchParams();
      params.append("beginDate", BeginDate);
      params.append("endDate", EndDate);
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }

      this.$store
        .dispatch("GetPersonDayWorks", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            //this.list = result.data.Table;
          } else{
            this.onErrorFetchFunctionality()
          }
        });
    },
    GetPersonPeriodWorkDetail(type) {
      const params = new URLSearchParams();
      params.append("period", this.args.period);
      params.append("year", this.args.year);
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }

      let isPeriod = true;
      if (type == "1") {
        isPeriod = true;
      }
      params.append("isPeriod", isPeriod);

      this.$store
        .dispatch("GetPersonPeriodWorkDetail", { params })
        .then((result) => {
          //console.log(result);
          if (result.type === "success") {
            this.details = result.data.Table[0];
            this.details.year = this.args.year;
            this.details.isPeriod = true;
          }
        });
    },
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var canPrint = false;

        var adminPermissionList =
          this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            canPrint = true;
            return false;
          }
          return true;
        });

        if (!canPrint) {
          var permission = this.$store.state.personel.personelDetail.Permission;
          if (permission[19].toString() == "1") {
            this.visiblePrint = true;
          }
        }
      }
    },
    getPersonelName() {
      debugger
      const params = new URLSearchParams();
      if (this.args.perno) {
        params.append("perno", this.args.perno);
      }
      this.$store
        .dispatch("GetPersonFullName", { params })
        .then((result) => {
          debugger
          ////console.log(result);
          if (result.type === "success") {
            if (result.data.length > 0) {
              // this.personelName= result.data
              this.personelName = result.data+' - ' + 'با شماره پرسنلی '+"( " + this.args.perno + " )";
            }
          }
        });
    },
    print() {
      var dp = "";
      if (this.args.perno) {
        dp = this.args.perno;
      } else {
        dp = this.$store.state.auth.auth.username;
      }

      let routeData = this.$router.resolve({
        name: "rpPersonelPeriodWorkDetail",
        query: { Y: this.args.year, P: this.args.period, POM: "P", dp: dp },
      });
      window.open(routeData.href, "_blank");
    },
  },
  data() {
    return {
      args: {},
      DisableShowingMorLeft: true,
      DisableShowingFunctionality: false,
      details: "details",
      personelName:'',
      tabs: [
        { id: "totalIO", title: "PeriodWorkDetails.tabs.totalIO" },
        {
          id: "totalMorakhasi",
          title: "PeriodWorkDetails.tabs.totalMorakhasi",
        },
        { id: "totalMissions", title: "PeriodWorkDetails.tabs.totalMissions" },
        {
          id: "detailsFunctionality",
          title: "PeriodWorkDetails.tabs.detailsFunctionality.title",
        },
        {
          id: "detailsMorakhasi",
          title: "PeriodWorkDetails.tabs.detailsMorakhasi.title",
        },
      ],
      panel: [],
      items: [
        {
          title: "PeriodWorkDetails.FunctionalDetails.title",
          content: FunctionalDetails,
        },
        {
          title: "PeriodWorkDetails.KasrKarDetails.title",
          content: KasrKarDetails,
        },
        {
          title: "PeriodWorkDetails.ExtraWorkDetails.title",
          content: ExtraWorkDetails,
        },
        {
          title: "PeriodWorkDetails.MorakhasiDetails.title",
          content: MorakhasiDetails,
        },
        {
          title: "PeriodWorkDetails.MamoriatDetails.title",
          content: MamoriatDetails,
        },
        {
          title: "PeriodWorkDetails.HolidayDetails.title",
          content: HolidayDetails,
        },
      ],
    };
  },
};
</script>

<style>
.periodWorkDetail .v-expansion-panel-content *{
  padding: 0px;
}
</style>